import React from 'react'

const Url = ({ url, name, href }) => (
    <a href={href} className="text-blue-400"
        rel="external"
        to={url}> {name} </a>
)

export default Url